import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import {
  Button,
  Checkbox,
  Col,
  Form,
  Image,
  Input,
  Modal,
  Radio,
  Row,
  Typography,
  Upload
} from 'antd';
import { Editor } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import '../../../../styles/pages/seller/_sellers.scss';
import { DownloadIcon } from '@root/core/components/Icon';
import { ViewerBox } from '../components/ViewerBox';
import { useState, useEffect, useRef } from 'react';
import { CloseOutlined, PaperClipOutlined } from '@ant-design/icons';
import FormItem from '../components/FormItem';
import DetailsPro from '@root/modules/Forwarder/Detail/components/DetailsPro';
import ShipmentMethodCanEdit from '@root/modules/Warehouse/Inquiry/components/shipping/ShipmentMethodCanEdit';
import ShippingPlant from '@root/modules/Warehouse/Inquiry/components/shipping/ShippingPlant';
import CheckPoint from '@root/modules/Warehouse/Shared/Common/CheckPoint';
import { useParams } from 'react-router';
import buskforwardingdetail from '../../Forwarding-Deatil/services/buskforwardingdetail';

interface MessageDetail {
  status: string;
  postDialogs: {
    id: number;
    canEdit: boolean;
    writerType: string;
    writerName: string;
    content: string;
    created_at: string;
    dialogFiles: {
      uploadFile: {
        fileName: string;
        url: string;
        id: number;
      };
    }[];
  }[];
  quotation: any;
  seller: any;
  cancelStatus: string;
}

const ForwardingContent = () => {
  const breadcrumbList = [
    {
      tittle: '포워딩 업체 관리',
      url: '/admin/busk/forwarding'
    },
    {
      tittle: '셀러 대화 목록',
      url: ''
    }
  ];
  const [fileList, setFileList] = useState<any[]>([]);
  const { postId } = useParams<{ postId: string }>();
  const [messageDetail, setMessageDetail] = useState<MessageDetail>();
  const [mode, setMode] = useState<'edit' | 'create'>('create');
  const [selectedIdx, setSelectedIdx] = useState(0);
  const editorRef = useRef<Editor>(null);

  const handleUploadChange = (e: any) => {
    if (e.target.files[0]) {
      setFileList([...fileList, e.target.files[0]]);
    }
  };
  const onUploadImage = async (blob: File, callback: any) => {
    const url = await buskforwardingdetail.uploadFile([blob]);
    callback(url.data.attachments[0].url, '');
    return false;
  };

  const handleFileDelete = (fileName: string) => {
    setFileList(
      fileList.filter((file) => {
        if ('name' in file && !('uploadFile' in file)) {
          return file.name !== fileName;
        }
        return file.uploadFile.fileName !== fileName;
      })
    );
  };
  console.log(messageDetail, '123123');
  const handleDownload = (url: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchData = async () => {
    const res = await buskforwardingdetail.getDetail(Number(postId));
    setMessageDetail(res.data);
  };

  useEffect(() => {
    fetchData();
  }, [postId]);

  useEffect(() => {
    if (mode === 'edit' && messageDetail?.postDialogs[selectedIdx]?.content) {
      setContent(messageDetail.postDialogs[selectedIdx].content);
      editorRef.current
        ?.getInstance()
        .setMarkdown(messageDetail.postDialogs[selectedIdx].content);
      setFileList(messageDetail.postDialogs[selectedIdx].dialogFiles || []);
    } else if (mode === 'create') {
      setContent('');
      editorRef.current?.getInstance().setMarkdown('');
      setFileList([]);
    }
  }, [mode, selectedIdx, messageDetail]);

  const [content, setContent] = useState('');
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onUpdate = async () => {
    try {
      if (mode === 'edit' && messageDetail?.postDialogs[selectedIdx]) {
        const dialogId = messageDetail.postDialogs[selectedIdx].id;
        let filesId = [];

        // 새로 업로드된 파일이 있는 경우에만 파일 업로드 API 호출
        const newFiles = fileList.filter(
          (file) => 'name' in file && !('uploadFile' in file)
        ) as File[];
        if (newFiles.length > 0) {
          const files = await buskforwardingdetail.uploadFile(newFiles);
          filesId = files?.data?.attachments?.map((file: any) => file.id);
        }

        // 기존 파일들의 ID 추가
        const existingFileIds = fileList
          .filter((file) => 'uploadFile' in file)
          .map((file) => file.uploadFile.id);

        filesId = [...filesId, ...existingFileIds];

        await buskforwardingdetail.updateDialog(dialogId, filesId, content);
        await fetchData();
        setContent('');
        setFileList([]);
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error('Failed to update message:', error);
    }
  };

  console.log(messageDetail, '123123');

  return (
    <div className="shipping-detail">
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <div
          style={{
            position: 'sticky',
            top: 63,
            backgroundColor: '#f0f2f5',
            zIndex: 100
          }}
        >
          <div
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: 'white'
            }}
          >
            <Row>
              <Col flex={10} style={{ paddingTop: '5px' }}>
                <span style={{ fontWeight: 500, fontSize: 12 }}>
                  {messageDetail?.seller?.companyName}
                </span>

                <span
                  style={{ marginLeft: 18, color: '#777777', fontSize: 10 }}
                >
                  {messageDetail?.seller?.email}
                </span>
              </Col>
              <Col flex={0.1}>
                <Button
                  disabled={messageDetail?.cancelStatus === 'CancelComplete'}
                  onClick={() => {
                    setMode('create');
                    setIsModalOpen(true);
                  }}
                >
                  글 작성하기
                </Button>
              </Col>
            </Row>
          </div>
          {messageDetail?.cancelStatus !== 'CancelComplete' && (
            <Button
              className="btn-style"
              onClick={async () => {
                await buskforwardingdetail.forceCancel(Number(postId));
                await fetchData();
                alert('대화가 종료되었습니다.');
              }}
              style={{
                backgroundColor: '#D98282',
                color: 'white',
                marginTop: 10
              }}
            >
              대화 종료
            </Button>
          )}
          {messageDetail?.cancelStatus === 'CancelComplete' && (
            <p
              style={{
                color: '#D98282',
                marginTop: 8,
                fontSize: 12,
                fontWeight: 500
              }}
            >
              대화가 종료되었습니다.
            </p>
          )}

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 10,
              marginBottom: 5
            }}
          >
            {messageDetail?.quotation && (
              <Typography.Text
                style={{
                  background: 'rgb(43, 44, 81)',
                  padding: '0.25rem 2rem',
                  borderRadius: '1rem',
                  color: 'white'
                }}
              >
                {messageDetail?.status || 'Inprogress'}
              </Typography.Text>
            )}
          </div>
        </div>
        <div style={{ overflow: 'auto' }}>
          {messageDetail?.postDialogs?.map((data, idx) => (
            <div key={idx} style={{ marginTop: idx === 0 ? 0 : 24 }}>
              <ViewerBox
                imgSrc={`/images/${
                  data.writerType === 'Seller'
                    ? 'S'
                    : data.writerType === 'Admin'
                    ? 'B'
                    : 'F'
                }.png`}
                initialValue={data.content}
                name={
                  data.writerType === 'Seller'
                    ? messageDetail?.seller?.companyName
                    : data.writerName
                }
                date={new Date(data.created_at)}
              />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: 8
                }}
              >
                <div style={{ display: 'flex', gap: 12 }}>
                  {data.dialogFiles?.map((file, key) => (
                    <Button
                      key={key}
                      onClick={() =>
                        handleDownload(
                          file.uploadFile.url,
                          file.uploadFile.fileName
                        )
                      }
                      style={{
                        padding: '0px 12px',
                        height: 30,
                        fontSize: 12,
                        borderRadius: 8,
                        display: 'flex',
                        gap: 8,
                        alignItems: 'center'
                      }}
                    >
                      <span>{file.uploadFile.fileName}</span>
                      <DownloadIcon />
                    </Button>
                  ))}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  {data.canEdit && (
                    <Button
                      disabled={
                        messageDetail?.cancelStatus === 'CancelComplete'
                      }
                      onClick={() => {
                        setSelectedIdx(idx);
                        setMode('edit');
                        setIsModalOpen(true);
                      }}
                      style={{
                        fontSize: 12,
                        fontWeight: 500,
                        padding: '0px 30px',
                        borderRadius: 8
                      }}
                    >
                      수정
                    </Button>
                  )}
                  {messageDetail?.quotation && idx === 0 && (
                    <Button
                      onClick={() => setIsDetailOpen(true)}
                      style={{
                        backgroundColor: '#2B2C51',
                        color: 'white',
                        fontSize: 12,
                        fontWeight: 500,
                        borderRadius: 8
                      }}
                    >
                      견적 요청서 &gt;
                    </Button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Modal
        width={'auto'}
        closeIcon={<CloseOutlined />}
        onCancel={() => setIsModalOpen(false)}
        title="메세지 작성"
        className="forwarding-modal"
        visible={isModalOpen}
        footer={[
          <button
            onClick={async () => {
              if (mode === 'edit') {
                await onUpdate();
              } else {
                let filesId = [];

                // 새로 업로드된 파일이 있는 경우에만 파일 업로드 API 호출
                const newFiles = fileList.filter(
                  (file) => 'name' in file && !('uploadFile' in file)
                ) as File[];
                if (newFiles.length > 0) {
                  const files = await buskforwardingdetail.uploadFile(newFiles);
                  filesId = files?.data?.attachments?.map(
                    (file: any) => file.id
                  );
                }

                // 기존 파일들의 ID 추가
                const existingFileIds = fileList
                  .filter((file) => 'uploadFile' in file)
                  .map((file) => file.uploadFile.id);

                filesId = [...filesId, ...existingFileIds];

                await buskforwardingdetail.createDialog({
                  postId: Number(postId),
                  content: content,
                  attachment: filesId
                });
                await fetchData();
                setContent('');
                setFileList([]);
                setIsModalOpen(false);
              }
            }}
            disabled={!!!content}
            className="forwarding-btn"
          >
            {mode === 'edit' ? '저장' : '메세지 전송'}
          </button>
        ]}
        centered
      >
        <Editor
          hooks={{
            addImageBlobHook: (blob, callback) =>
              onUploadImage(blob as File, callback)
          }}
          initialEditType="wysiwyg"
          ref={editorRef}
          onChange={() => {
            const markdown =
              editorRef.current?.getInstance()?.getMarkdown() || '';
            setContent(markdown);
          }}
          hideModeSwitch={true}
        />
        <div className="file-wrap">
          <label htmlFor="file" className="file-btn">
            <span style={{ whiteSpace: 'nowrap' }}>파일</span>
            <PaperClipOutlined width={16} height={16} />
          </label>
          <input
            onChange={handleUploadChange}
            type="file"
            id="file"
            style={{ display: 'none' }}
          />
          <div style={{ display: 'flex', gap: 12, overflowX: 'auto' }}>
            {fileList.map((file, index) => (
              <Button className="file-name" key={index}>
                <span>
                  {'name' in file && !('uploadFile' in file)
                    ? file.name
                    : file.uploadFile.fileName}
                </span>
                <CloseOutlined
                  onClick={() =>
                    handleFileDelete(
                      'name' in file && !('uploadFile' in file)
                        ? file.name
                        : file.uploadFile.fileName
                    )
                  }
                />
              </Button>
            ))}
          </div>
        </div>
      </Modal>

      <Modal
        footer={null}
        centered
        width={1200}
        className="shipping-detail forwarding-modal"
        title="견적 요청서 상세"
        visible={isDetailOpen}
        onCancel={() => setIsDetailOpen(false)}
      >
        <DetailsPro {...messageDetail?.quotation?.products?.[0]} />

        <div
          style={{
            display: 'flex',
            marginTop: '15px',
            gap: '10px'
          }}
        >
          <ShipmentMethodCanEdit
            shipmentMethod={messageDetail?.quotation?.shipmentMethod}
          />
          <ShippingPlant
            shippingPlanEta={messageDetail?.quotation?.shippingPlanEta}
            shippingPlanEtd={messageDetail?.quotation?.shippingPlanEtd}
          />
          <CheckPoint
            data={{ checkPoint: messageDetail?.quotation?.comment }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ForwardingContent;
